import moment from 'moment';

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export const CUSTOM_DATE_FORMAT = 'Do MMMM YYYY';

export const formatDateTime = (date) => {
  let formattedDateTime = moment(date).format('DD MMM YYYY, LT');
  return formattedDateTime;
};

export const formatDate = (date) => {
  let formattedDate = moment(date).format('DD MMM YYYY');
  return formattedDate;
};

export const formatDateToUTC = (date) => {
  let utcDate = moment(date).utc()._d.toISOString();
  return utcDate;
};

export const formatTimeTo12H = (time) => {
  let formattedTime = moment(time, ['hh:mm']).format('h:mm A');
  return formattedTime;
};

export const formatTime = (orderTime, time) => {
  let formattedTime = moment(orderTime).add(time, 'm').format('h:mm A');
  return formattedTime;
};

export const formatTimeToLTS = (time) => {
  let formattedTime = moment(time).format('LTS');
  return formattedTime;
};

export const dateTimeConcat = (date, time) => {
  let dateTime = moment(date + ' ' + time).format();
  return dateTime;
};

export const getTodayDate = () => {
  return moment();
};

export const getYesterdayDate = () => {
  return moment().subtract(1, 'days');
};

export const getStartOfWeek = () => {
  return moment().startOf('week');
};

export const getStartOfMonth = () => {
  return moment().startOf('month');
};

export const formatDateToISO = (date) => {
  return moment(date).format(ISO_DATE_FORMAT);
};

export const getLastWeek = () => {
  let fromDate = moment().subtract(1, 'weeks').startOf('week');
  let toDate = moment().subtract(1, 'weeks').endOf('week');

  return { fromDate, toDate };
};

export const getLastMonth = () => {
  let fromDate = moment().subtract(1, 'months').startOf('month');
  let toDate = moment().subtract(1, 'months').endOf('month');

  return { fromDate, toDate };
};

export const getTodayDay = () => moment().format('dddd');

export const getISODateFormat = (date) =>
  `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

export const formatTimeTo24H = (time) => moment(time, 'HH:mm');

export const formatDateTo24H = (date) => date.format('HH:mm');

export const formatDateToFormat = (date, format) => {
  let formattedDateTime = moment(date).format(format);
  return formattedDateTime;
};
